/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsothermColor {
}

export enum IsothermColor_Enum {
  kRed = 0,
  kGreen = 1,
  kBlue = 2,
  kYellow = 3,
  kCyan = 4,
  kMagenta = 5,
  kGray = 6,
  UNRECOGNIZED = -1,
}

export function isothermColor_EnumFromJSON(object: any): IsothermColor_Enum {
  switch (object) {
    case 0:
    case "kRed":
      return IsothermColor_Enum.kRed;
    case 1:
    case "kGreen":
      return IsothermColor_Enum.kGreen;
    case 2:
    case "kBlue":
      return IsothermColor_Enum.kBlue;
    case 3:
    case "kYellow":
      return IsothermColor_Enum.kYellow;
    case 4:
    case "kCyan":
      return IsothermColor_Enum.kCyan;
    case 5:
    case "kMagenta":
      return IsothermColor_Enum.kMagenta;
    case 6:
    case "kGray":
      return IsothermColor_Enum.kGray;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IsothermColor_Enum.UNRECOGNIZED;
  }
}

export function isothermColor_EnumToJSON(object: IsothermColor_Enum): string {
  switch (object) {
    case IsothermColor_Enum.kRed:
      return "kRed";
    case IsothermColor_Enum.kGreen:
      return "kGreen";
    case IsothermColor_Enum.kBlue:
      return "kBlue";
    case IsothermColor_Enum.kYellow:
      return "kYellow";
    case IsothermColor_Enum.kCyan:
      return "kCyan";
    case IsothermColor_Enum.kMagenta:
      return "kMagenta";
    case IsothermColor_Enum.kGray:
      return "kGray";
    case IsothermColor_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIsothermColor(): IsothermColor {
  return {};
}

export const IsothermColor = {
  encode(_: IsothermColor, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsothermColor {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsothermColor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IsothermColor {
    return {};
  },

  toJSON(_: IsothermColor): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IsothermColor>, I>>(base?: I): IsothermColor {
    return IsothermColor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsothermColor>, I>>(_: I): IsothermColor {
    const message = createBaseIsothermColor();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
